import React, {Component} from 'react';
import { connect } from 'react-redux';

import PeopleYouMayKnow from "../../../FeedContainer/PeopleYouMayKnow";
import Remainingpromotion from "../../../Promotion/PromotionBody/remainingpromotion";
import AddboxRight from "../../../FeedContainer/AddboxRight";
import Timeline from "./timeline";
import ChatBox from "../../../FeedContainer/ChatBox";
/* import Feed from "./../../../FeedContainer/Feed"; */

class UserFeeds extends Component {
    constructor(props) {
      super(props);
      this.state = {
        urlId      : this.props.urlId,
      };
    }
    componentDidMount() {
      this.setState({
        userImage         : this.props.currentUserDetails.user.image,
        
      })
     
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
       })
    }
    render() {
      return (
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
                <Remainingpromotion />
                
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area">
               {(this.props.currentUserDetails.user.membership != "GOLD") ?
                <AddboxRight />
                : null 
               }
                <ChatBox />
            </div>
            
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 post_area">
              <div className="row">
                <Timeline urlId={this.state.urlId} currentUserDetails={this.props.currentUserDetails}/>
              </div>
            </div>
        </div>
    
      );
    }
}

const mapStateToProps = state => {
 
  return {
    listOfFeed         : state.listfeed,
    currentUserDetails : state.login,
    
  }
}



export default connect(
  mapStateToProps
)(UserFeeds);

